<template><svg v-bind="$attrs"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 16">
  <path d="M.398 7.395c-.33.33-.33.88 0 1.21l7.11 7.148c.367.33.917.33 1.247 0l.843-.844c.33-.33.33-.88 0-1.246L3.953 7.982l5.645-5.645c.33-.367.33-.917 0-1.247L8.755.247c-.33-.33-.88-.33-1.246 0L.398 7.395z"/>
</svg>
</template>